import { render, staticRenderFns } from "./后台链接.vue?vue&type=template&id=862f9948&scoped=true"
import script from "./后台链接.vue?vue&type=script&lang=js"
export * from "./后台链接.vue?vue&type=script&lang=js"
import style0 from "./后台链接.vue?vue&type=style&index=0&id=862f9948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862f9948",
  null
  
)

export default component.exports